"use client";

import { useEffect } from "react";

import {
  SUPPLY_TIER_COOKIE,
  SUPPLY_TIER_COOKIE_MAX_AGE,
  type SupplyTierCookieValue,
} from "../_lib/tier";

/**
 * Persists the signed-in actor's tab set into the `fb_supply_tier` cookie so
 * the next document load's boot script can resolve Approvals-tab visibility
 * PRE-PAINT (see SupplyTabBar / app/supply/_lib/tier). Rendered by the tab bar
 * only on pages that actually know the capability; loading skeletons render
 * the bar without it and simply reuse whatever the cookie already holds —
 * which is exactly what keeps the bar's markup identical across a navigation
 * (no Approvals flicker). Also updates the live `data-supply-tier` attribute
 * so the CURRENT page reflects the capability immediately, not just the next
 * navigation. CluckupTierCookieSync ported, capability boolean instead of a
 * tier enum.
 *
 * Writing the cookie from a Server Component would break PPR (cookies()
 * forces dynamic) and isn't allowed during render, so this runs in a mount
 * effect.
 */
export function SupplyTierCookieSync({ approver }: { approver: boolean }) {
  useEffect(() => {
    const value: SupplyTierCookieValue = approver ? "full" : "floor";
    document.cookie = `${SUPPLY_TIER_COOKIE}=${value}; path=/; max-age=${SUPPLY_TIER_COOKIE_MAX_AGE}; SameSite=Lax`;
    const root = document.querySelector<HTMLElement>("[data-supply]");
    if (root) root.dataset.supplyTier = value;
  }, [approver]);

  return null;
}
